<template>
    <ValidationObserver :ref="work.id +'history'">
        <div
            v-if="! isActive"
            class="dashed-border-block"
        >
            <div class="row align-items-center">
                <div class="col-8">
                    <p class="mb-0"><b>{{ work.employer_name }} /</b> {{ work.employer_position }}</p>
                </div>
                <div class="col-4 text-right">
                    <a href="#" class="edit-link">
                        <img src="/uploads/img/svg/edit.svg" @click="$emit('activate', index)">
                    </a>
                    <a href="#" class="delete-link ml-2">
                        <img src="/uploads/img/svg/on.svg" @click.prevent="$emit('remove', index)">
                    </a>
                </div>
            </div>
        </div>
        <div class="dashed-border-block" v-else>
            <div class="row align-items-center">

                <ValidationProvider
                    name="Employer name"
                    rules="latinAndNumbers|min:2|max:500"
                    v-slot="{ errors }"
                    class="col-md-6"
                >
                    <div class="form-group form-group-1">
                        <label
                            for="" class="form-label">
                            Employer name
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="work.employer_name"
                        >
                        <FormError :error="errors[0]" name="Employer name"></FormError>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    name="Position"
                    rules="latinAndNumbers|min:2|max:500"
                    v-slot="{ errors }"
                    class="col-md-6"
                >
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Position</label>
                        <input type="text" class="form-control" v-model="work.employer_position">
                        <form-error :error="errors[0]" name="Position"></form-error>
                    </div>
                </ValidationProvider>

                <div class="col-md-4">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">City</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="work.employer_city"
                        >
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Country</label>
                        <select
                            class="custom-select"
                            v-model="work.country_id"
                        >
                            <option
                                v-for="country in countries"
                                :value="country.id"
                            >
                                {{ country.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-4" v-show="work.country_id === 187">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">State</label>
                        <select class="custom-select" v-model="work.state">
                            <option
                                v-for="state in states"
                                :value="state.id"
                            >
                                {{state.name}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Start Date</label>
                        <date-picker
                            style="width: 100%;"
                            value-type="format"
                            format="YYYY-MM-DD"
                            v-model="work.start_day"
                        ></date-picker>
                    </div>
                </div>
                <div v-if="!work.is_working" class="col-md-6 col-lg-4">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">End Date</label>
                        <date-picker
                            style="width: 100%;"
                            value-type="format"
                            format="YYYY-MM-DD"
                            v-model="work.end_day"
                        ></date-picker>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group form-group-1">
                        <div class="form-check">
                            <input class="form-check-input-checkbox" type="checkbox" name="name12" id="office-office" v-model="work.is_working" value="yes">
                            <label class="form-check-label" for="office-office">
                                Still employed here
                            </label>
                        </div>
                    </div>
                </div>
                <ValidationProvider name="Starting pay per hour" v-slot="{errors}" rules="numeric|min:1|max:3" class="col-sm-6">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Starting pay per hour</label>
                        <input type="text" class="form-control" v-model="work.starting_payment">
                        <FormError :error="errors[0]" name="Starting pay per hour"></FormError>
                    </div>
                </ValidationProvider>

                <ValidationProvider name="Ending pay per hour" v-slot="{errors}" rules="numeric|min:1|max:3" class="col-sm-6">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Ending pay per hour</label>
                        <input type="text" class="form-control" v-model="work.ending_payment">
                        <FormError :error="errors[0]" name="Ending pay per hour"></FormError>
                    </div>
                </ValidationProvider>

                <ValidationProvider name="Reason for leaving" rules="latinAndNumbers|min:2|max:500" v-slot="{ errors }"class="col-sm-12">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">What was the reason for leaving</label>
                        <input type="text" class="form-control" v-model="work.reason_leaving">
                        <FormError :error="errors[0]" name="Reason for leaving"></FormError>
                    </div>
                </ValidationProvider>

                <ValidationProvider name="Job Duties" rules="latinAndNumbers|min:2|max:500" v-slot="{ errors }" class="col-sm-12">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Job Duties</label>
                        <textarea type="text" class="form-control" v-model="work.duties"></textarea>
                        <FormError :error="errors[0]" name="Job Duties"></FormError>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    name="Supervisor name"
                    rules="latinAndNumbers|min:2|max:500"
                    v-slot="{ errors }"
                    class="col-sm-12"
                >
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Name of direct supervisor</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="work.direct_supervisor_name"
                        >
                        <FormError :error="errors[0]" name="Supervisor name"></FormError>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    rules="customMin:17"
                    name="Employer Phone"
                    v-slot="{ errors }"
                    class="col-md-6"
                >
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Employer Phone</label>
                        <input
                            type="text"
                            class="form-control"
                            v-mask="'+1 (###) ###-####'"
                            v-model="work.employer_phone"
                        >
                        <FormError :error="errors[0]" name="Employer Phone"></FormError>
                    </div>
                </ValidationProvider>
                <div class="col-md-6">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">May we contact the employer?</label>
                        <div class="buttons-type-multiselect two-btns">
                            <div class="item">
                                <input
                                    type="radio"
                                    name="name12"
                                    class="rad"
                                    id="id-122"
                                    value="1"
                                    v-model="work.contacting"
                                >
                                <label for="id-122">
                                    <div class="ttl">Yes</div>
                                </label>
                            </div>
                            <div class="item">
                                <input
                                    type="radio"
                                    name="name12"
                                    class="rad"
                                    id="id-133"
                                    value="0"
                                    v-model="work.contacting"
                                >
                                <label for="id-133">
                                    <span class="ttl">No</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-right">
                    <a
                        class="add-link img-btn"
                        @click="savePosition"
                    >
                        <img src="/uploads/img/svg/diskette.svg" alt="save">
                        Save
                    </a>
                </div>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>


export default{
    name: "WorkHistoryItem",
    emits: ['activate', 'remove'],
    props: {
        isActive: {
            default: false,
            type: Boolean
        },
        work: {
            type: Object,
        },
        index: {
            type: Number
        },
        states: {
            type: Array
        },
        countries: {
            type: Array,
            required: true
        }

    },
    methods:{
        activatePosition() {
            this.$emit('activate', null);
        },
        savePosition() {
            (async () => {
                const valid = await this.$refs[`${this.work.id}history`].validate();
                if (!valid) {
                    this.$showValidationErrorMessage();
                    return
                } else {
                    this.activatePosition();
                }

            })();
        },
    },
}

</script>

<style scoped>

</style>
